// extracted by mini-css-extract-plugin
export default {"pageContent":"styles_pageContent__WW6bg"};